import React from "react";
import { connect } from "react-redux";
import { updateQuantity, removeFromCart } from "../redux/actions/cartActions";
import { Link } from "react-router-dom";

const CartPage = ({ cart, updateQuantity, removeFromCart }) => {
  const { items } = cart;

  // Calculate subtotal
  const subtotal = items.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );
  return (
    <>
      <div className="flex justify-center w-full bg-gray-50 p-3">
        <h2 className="text-xl font-bold text-center">Shopping Cart</h2>
      </div>
      <div className="container mx-auto md:px-28 px-8 py-8">
        <div className="flex justify-end items-center pb-4">
          <div className="text-right">
            <p className="text-lg font-semibold text-center">
              Subtotal: Rs. {subtotal.toLocaleString()}
            </p>
              <button className="mt-2 md:px-24 px-6 py-2 bg-black text-white rounded-md font-medium">
              {items.length > 0 ? (
                <Link to="/checkout">Checkout</Link>
              ) : (
                "Checkout"
              )}
              </button>
          </div>
        </div>

        <div className="mt-6 flex justify-center">
          <div className="w-full">
           
            {items.length ? (
              <>
               <div className="grid grid-cols-12 border-b border-gray-300 pb-3 text-sm text-gray-700 font-medium">
              <span className="col-span-5 text-base font-semibold uppercase">
                Product
              </span>
              <span className="col-span-2 text-base font-semibold uppercase text-center">
                Price
              </span>
              <span className="col-span-2 text-base font-semibold uppercase text-center">
                Quantity
              </span>
              <span className="col-span-3 text-base font-semibold uppercase text-center">
                Total
              </span>
            </div>
              {items.map((item, index) => (
                <div
                  key={index}
                  className="grid grid-cols-12 items-center py-4 border-b border-gray-200"
                >
                  <div className="col-span-5 flex items-start space-x-4">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-16 h-22 object-cover"
                    />
                    <div>
                      <h2 className="text-sm font-semibold uppercase">
                        {item.name}
                      </h2>
                      <p className="text-xs text-gray-600">Size: {item.size}</p>
                      <div className="mt-3">
                        <button
                          onClick={() => removeFromCart(item.id)}
                          className="text-black hover:text-red-700 text-sm"
                        >
                          <i className="fas fa-trash-alt"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <p className="col-span-2 text-center text-sm font-medium">
                    Rs. {item.price.toLocaleString()}
                  </p>
                  <div className="col-span-2 text-center">
                    <div className="">
                      <button
                        onClick={() =>
                          updateQuantity(
                            item.id,
                            item.size,
                            item.color,
                            item.quantity - 1
                          )
                        }
                        disabled={item.quantity === 1}
                        className="mx-2"
                      >
                        <i className="fa-solid fa-circle-minus"></i>
                      </button>
                      <span className="px-2">{item.quantity}</span>
                      <button
                        onClick={() =>
                          updateQuantity(
                            item.id,
                            item.size,
                            item.color,
                            item.quantity + 1
                          )
                        }
                        className="mx-2"
                      >
                        <i className="fa-solid fa-circle-plus"></i>
                      </button>
                    </div>
                  </div>
                  <p className="col-span-3 text-center text-sm font-medium">
                    Rs. {(item.price * item.quantity).toLocaleString()}
                  </p>
                </div>
              ))}
              </>
            ) : (
              <div className="text-center md:my-10 my-5">
                <div className="flex justify-center mb-4">
                  <img
                    src="https://cdn-icons-png.flaticon.com/512/8899/8899851.png" // Sample icon
                    alt="Empty Cart"
                    className="w-24 h-24"
                  />
                </div>
                <h2 className="text-xl font-bold">YOUR CART IS EMPTY</h2>
                <p className="text-gray-500 mt-2">
                  Before proceeding to checkout, you must add some products to
                  your shopping cart. You will find a lot of interesting
                  products on our "Shop" page.
                </p>
                <div className="mt-6">
                  <Link to="/">
                    <button className="px-6 py-2 bg-black text-white rounded-lg">
                      RETURN TO SHOP
                    </button>
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  cart: state.cart,
});

const mapDispatchToProps = {
  updateQuantity,
  removeFromCart,
};

export default connect(mapStateToProps, mapDispatchToProps)(CartPage);
